/**
 * Safely reads a nested property from an object.
 * Returns defaultValue ('N/A' by default) if any step is missing or undefined.
 * If the property exists—even if it’s an empty string—it will return that value.
 *
 * @param {object} obj       The object you’re reading from.
 * @param {string} path      Dot-delimited path, e.g. 'description.difficulty'.
 * @param {*}      defaultValue  Value to return if lookup fails (defaults to 'N/A').
 */
export function getValue(obj, path, defaultValue = 'N/A') {
    const keys = path.split('.');
    let val = obj;
  
    for (const key of keys) {
      if (val != null && Object.prototype.hasOwnProperty.call(val, key)) {
        val = val[key];
      } else {
        return defaultValue;
      }
    }
  
    // If the final value is strictly undefined, fall back; otherwise return it (even '' or 0)
    return val === undefined ? defaultValue : val;
  }